<template>
  <div class="booker">
  
    <el-row v-show='expiry' class='exp-timer'>
      <el-col span="24">
        {{ formatExpiry }}
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <!-- FIELD BOOKING -->
      <el-col :lg="{span: 18}" :md="{span: 18}" :sm="{span: 18}" :xs="{span: 24}">

        <div v-if="showPaymentArea">
          <paymentform
            :customer="stripeCustomer"
            @recheck="checkCustomer"
            @confirm='onPaymentConfirm'
            @cancel='onPaymentCancel'>
          </paymentform>
        </div>
        <div v-else-if="showLargeLogin">
          <largelogin></largelogin>
        </div>
        <div v-else-if="showSuccessScreen">
          <successscreen
           :bookingData="bookingDataCopy">
          </successscreen>
        </div>
        <div v-else>
          <selectionform
            :bookingData="bookingData"
            @type='onTypeSelected'
            @site='onSiteSelected'
            @duration='onDurationSelected'
            @scene='onSceneSelected'
            @date='onDateSelected'
            @time='onTimeSelected'>
          </selectionform>
        </div>
      </el-col>
      

      <!-- BOOKING SUMMARY -->
      <el-col :lg="{span: 6}" :md="{span: 6}" :sm="{span: 6}" :xs="{span: 24}">
        <div class="panelheader border-blue">
          <div class="booker-title">Booking Summary</div>
        </div>
        
        <div class="body">
          
          <ul style="list-style: none; padding-left: 10pt">
            <li v-for="(value, key) in bookingData" :key="key">
              <span style="font-weight: bold; float: left; text-transform: capitalize;">{{ key }}</span>
              <span style="float: right; text-transform: capitalize;">{{ value.name || value }}</span>
              <br>
            </li>
          </ul>

          <el-popover
            ref="processError"
            placement="bottom"
            title="Error"
            width="200"
            trigger="manual"
            :value="!dataIsValid"
            :content="popoverContent">
          </el-popover>

          <el-button
            v-if="showSuccessScreen"
            type="save"
            class="sum-button"
            @click="newBooking">
            New Booking
          </el-button>

          <el-button 
            v-else
            type="save" 
            class="sum-button" 
            @click="processBooking"
            v-popover:processError>
            {{ sumButtonLabel }}
          </el-button>
        </div>
      </el-col>
    
      <!-- LOGIN -->
      <div v-if="!userAuthenticated && !showLargeLogin">
        <el-col :lg="{span: 6}" :md="{span: 6}" :sm="{span: 6}" :xs="{span: 24}" style="float: right;">
          <div class="panelheader border-yellow">
            <div class="booker-title">Login</div>
          </div>
          
          <div class="body log-wrapper">
            <loginform></loginform>
          </div>
        </el-col>
      </div>
    </el-row>

  </div>
</template>

<script>

import selectionForm from './SelectionForm'
import paymentForm from './PaymentForm'
import loginForm from '../LoginForm'
import auth from '../../auth';

import largeLogin from './LargeLogin'
import successScreen from './SuccessScreen'

import requests from '../../requests'

export default {
  name: 'booker',
  data(){
    return {
      bookingData: {
        'type': '',
        'site': '',
        'scene': '',
        'duration': '',
        'date': '',
        'time': '',
      },
      tempid: '',
      bookingDataCopy: {},
      dataIsValid: true,
      popoverContent: '',
      showPaymentArea: false,
      userAuthenticated: false,
      stripeCustomer: '',
      showLargeLogin: false,
      showSuccessScreen: false,
      expired: false,
      expiry: '',
      formatExpiry: '',
    }
  },
  beforeMount(){
    auth.checkAuth();
    this.userAuthenticated = auth.user.authenticated;

    this.checkCustomer();

    var bkd = sessionStorage.getItem('bkd');
    if(bkd && bkd != 'eyJ0eXBlIjoiIiwic2l0ZSI6IiIsInNjZW5lIjoiIiwiZHVyYXRpb24iOiIiLCJkYXRlIjoiIiwidGltZSI6IiJ9') {

      var tempid = sessionStorage.getItem('bkdid');
      if(tempid) {
        this.tempid = atob(tempid);
      }

      var expiry = atob(sessionStorage.getItem('bkde'));
      this.expiry = expiry;
      
      var now = new Date();
      var then = new Date(parseInt(expiry));

      if(then > now) {
        bkd = JSON.parse(atob(bkd));
        this.bookingData = bkd; 

        if(this.userAuthenticated && this.validateData().length === 0) {
          this.showPaymentArea = true;
        }

      } else {
        this.removeStorage();
      }
    } else {
      this.removeStorage();
    }

    $(window).off('unload').on('unload', this.saveBookingData);
  },
  beforeDestroy(){
    this.saveBookingData();
  },
  beforeRouteUpdate(){
    this.saveBookingData();
  },
  methods: {
    onTypeSelected(type) {     
      this.bookingData.type = type;
      if(!type) {
        this.bookingData.site = '';
        this.bookingData.scene = '';        
      }
    },
    onSiteSelected(site) {
      this.bookingData.site = site;
      if(!site) {
        this.bookingData.scene = '';
      }
    },
    onDurationSelected(duration) {
      this.bookingData.duration = duration;
    },
    onSceneSelected(scene) {
      this.bookingData.scene = scene;
    },
    onDateSelected(date) {
      this.bookingData.date = date;
    },
    onTimeSelected(time) {
      this.bookingData.time = time.time;
    },
    checkCustomer() {
      if(this.userAuthenticated) {
        var profile = JSON.parse(auth.getProfile());
        var context = this;
        requests.getStripeCustomerFromUserId(context, profile.user_id, function(result){
          if(result.action === 'success') {
            context.stripeCustomer = result.data;
          } else {
            context.stripeCustomer = null;
          }
        });
      }
    },
    onPaymentConfirm(paymentData, isStripe) {
      //TODO: Make this more secure
      //      I dunno how though

      var context = this;
      var profile = JSON.parse(auth.getProfile());
      context.bookingDataCopy = Object.assign({}, context.bookingData);
      context.expiry = '';

      var makeBooking = new Promise((resolve, reject) => {
        
        var data = context.formatBookingData(context.bookingData);

        requests.newBooking(this, data, function (result) {
          console.log(result)
          console.log(data)
          if(result.action === 'success'){
            resolve(result);
          } else {
            context.$message({
              type: 'error',
              message: 'There was an error making your booking. Please try again.' + result.msg,
            });
            reject(result);
          }
        })
      });


      makeBooking.then((val)=> {
        if( isStripe ) {
          //Data for creating a new Stripe Customer
          var data = {
            token: paymentData.token.id,
            user: {
              id: profile.user_id,
              username: profile.username,
              email: profile.email
            }
          }

          var getCustomer = new Promise((resolve, reject) => {
            if(context.stripeCustomer) {
              resolve({customer: context.stripeCustomer, newCustomer: false});
            } else {
              requests.createStripeCustomer(context, data, function(result) {
                if(result.action !== 'success'){
                  reject(result);
                } else {
                  resolve({customer: result.data.customer, newCustomer: true});
                }
              });
            }
          })

          getCustomer.then((val) => {
            var customer = val.customer;
            var newCustomer = val.newCustomer;

            var source;
            if(newCustomer) {
              source = customer.default_source || customer.sources.data[0] || null;
              
            } else {
              source = (paymentData.newCC ? paymentData.token : paymentData.card) || null;
            }

            if(!source) {
              context.$message({type:'error', message:'Payment method error. Please try again'});
              console.log(customer);
              return;
            }

            var data = {
              customer: customer,
              token: paymentData.token,
              source: source,
              amount: 1500,
              description: "Payment for booking id: " + btoa(Math.random()).slice(3,14),
            }


            if(!newCustomer && paymentData.newCC) {
              //Add new source and charge it
              requests.chargeNewCard(context, data, function(result) {
                if(result.action !== 'success'){
                  context.$message({
                    type: 'error',
                    message: result.msg,
                  });
                } else {
                  context.paymentSuccess();
                }
              });
            } else {
              //Charge selected card
              requests.chargeCard(context, data, function(result) {
                if(result.action !== 'success'){
                  context.$message({
                    type: 'error',
                    message: result.msg,
                  });
                } else {
                  context.paymentSuccess();
                }
              });
            }
          });
        }
        //Is PayPal
        else {
          this.paymentSuccess();
        }
      });
    },
    formatBookingData(bookingData){
      var timeToSeconds = function(time) {
        if(!time) return 0;
        var t = time.split(':');
        return (+t[0])*60*60+(+t[1])*60+(+t[2]);
      }

      var secondsToTime = function(seconds) {
        seconds = seconds || 0;
        return new Date(new Date('1970-01-01').setSeconds(seconds)).toISOString().split('T')[1].split('.')[0]
      }

      var start_time = bookingData.time;

      var t = timeToSeconds(start_time + ':00');
      var d = timeToSeconds(bookingData.duration.time);      

      var end_time = secondsToTime(t+d).slice(0, -3);

      return {
        date: bookingData.date,
        start_time: start_time,
        end_time: end_time,
        field_id: 1,
        scene_id: bookingData.scene.id,
        site_id: bookingData.site.id
      };
    },
    paymentSuccess(){
      this.showPaymentArea = false;
      this.showSuccessScreen = true;
      this.bookingData = {'type': '', 'site': '', 'scene': '', 'duration': '', 'date': '', 'time': ''};
      this.removeStorage();
    },
    onPaymentCancel() {
      this.showPaymentArea = false;
    },
    validateData(){
      var invalids = [];

      for (var key in this.bookingData) {
        if (this.bookingData.hasOwnProperty(key)) {
          var value = this.bookingData[key];
          if(!value) {
            invalids.push(key);
          }
        }
      }
      return invalids;
    },
    processBooking() {
      var invalids = this.validateData();

      if(invalids.length > 0){
        this.dataIsValid = false;
        this.popoverContent = invalids.join(' cannot be empty. ') + ' cannot be empty.';
        setTimeout(() => {
          this.dataIsValid = true;
        }, 2000);
      } else {
        this.saveBookingData();
        
        if(this.userAuthenticated) {
          this.showPaymentArea = !this.showPaymentArea;
        } else {
          this.showLargeLogin = true;
        }
      }
    },
    newBooking(){
      this.showSuccessScreen = false;
      this.showPaymentArea = false;
    },
    saveBookingData() {
      var bkd = sessionStorage.getItem('bkd');
      var newbkd = btoa(JSON.stringify(this.bookingData));
      
      if(bkd && bkd === newbkd) {
        return;
      }

      var exp = (new Date().getTime() + (60*10*1000)); //Set expiry for 10mins
      this.expiry = exp;

      var context = this;
      
      var data = this.formatBookingData(this.bookingData);

      requests.newTempBooking(this, data, function(result) {
        if(result.action === 'success') {
          context.tempid = result.data; 
          sessionStorage.setItem('bkdid', btoa(context.tempid));          
        }
      });

      sessionStorage.setItem('bkd', newbkd);
      sessionStorage.setItem('bkde', btoa(exp));
    },
    removeStorage(){
      sessionStorage.removeItem('bkd');
      sessionStorage.removeItem('bkde');
      sessionStorage.removeItem('bkdid');
      this.expiry = ''

      if(this.tempid) {
        requests.deleteTempBooking(this, this.tempid, function (result) {
          this.tempid = '';
        });
      }
    },
  },
  watch: {
    expiry: function(newVal){
      if(newVal){
        var expInter = setInterval(()=>{
          var now = new Date().getTime();
          var distance = parseInt(this.expiry) - now;
          
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          if(minutes < 0 || seconds < 0){
            this.formatExpiry = "Your saved booking has expired. Please refresh and book again.";
            //Empty bookingData when expired
            for (var key in this.bookingData) { if (this.bookingData.hasOwnProperty(key)) {this.bookingData[key] = '';}}        
            this.removeStorage();
            this.expiry = '-1';
          } else {
            this.formatExpiry = `Your saved booking will expire in: ${minutes}min ${seconds}secs`;
          }
        }, 1000);
      } else {
        this.formatExpiry = '';
      }
    },
    bookingData: {
      handler(newVal, oldVal){
        if(JSON.stringify(oldVal) != '{"type":"","site":"","scene":"","duration":"","date":"","time":""}') {
          if(this.expiry){
            this.removeStorage();
          }
        }
      },
      deep: true,
    }
  },
  computed: {
    sumButtonLabel: function(){
      return this.showPaymentArea ? 'Edit Booking' : 'Process Booking'
    }
  },
  components: {
    'selectionform': selectionForm,
    'paymentform': paymentForm,
    'loginform' : loginForm,
    'largelogin': largeLogin,
    'successscreen': successScreen,
  }
}
</script>

<style>
  .body {
    background-color: white;
    padding: 10pt;
  }

  .booker-title {
    white-space: nowrap;
    font-size: 125%;
    float: left;
    font-weight: bold;
    padding: 12pt;
    color: #585858;
  }

  .exp-timer {
    margin-top: 30px;
    font-size: 120%;
    color: #C9C9C9;
  }

  .sum-button {
    width: 90%;
  }

  .border-yellow {
    border-color: #F5A623;
  }

  .body > .booking-select {
    margin: 12pt auto;
  }

  .flatpickr-input {
    display: none;
  }

  .datetime-wrapper {
    overflow: hidden;
    padding: 8pt;
  }

  .log-wrapper {
    padding: 24pt auto;
  }

  .el-button--select {
    background: #F3F3F5;
    color: #5B5B5B;
    border-radius: 0;
    border: none;
    margin: 6px 8px;
    width: 28%;
    float: left;
  }

  .el-button--select:hover, .el-button--select.time-selected {
    background: #33B0AE;
    color: #AEDFDF;
    border: none;
  }

  .dateTag {
    padding: 10px;
    margin: 10px auto;
    background: #147E9A;
    font-weight: bold;
    color: white;
    position: relative;
  }

  .dateTag:after {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-top-color: #147E9A;
    border-width: 8px;
    margin-left: -8px;
  }

  .el-tabs__item:not(.is-active){
    border: 1px solid #F4F5F6 !important;
    border-bottom-color: #d1dbe5 !important;
  }
  .el-tabs__item{
    margin: auto 3px;
  }

  .flatpickr-calendar {
    box-shadow: none;
  }

  .flatpickr-calendar .flatpickr-day {
    background: #F3F3F5;
    color: #5B5B5B;
  }

  .flatpickr-calendar .flatpickr-day:hover {
    background: #33B0AE;
    color: #AEDFDF;
  }

  .flatpickr-calendar .flatpickr-day.selected {
    background: #33B0AE;
    color: #AEDFDF;
  }
  
  .flatpickr-calendar .flatpickr-day.disabled {
    background: white;
    color: #EFEFEF;
  }
  
  .flatpickr-calendar .flatpickr-day.nextMonthDay{
    background: #FAFAFA;
    color: #DEADBE;
  }

</style>



// WEBPACK FOOTER //
// Booker.vue?2dbf6e32